var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 104,
    viewBox: "0 0 67 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_4248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.7904C0.5 13.8864 2.04358 12.3428 3.94767 12.3428H62.1758C64.0799 12.3428 65.6235 13.8863 65.6235 15.7904V103.126H0.5V15.7904Z",
    fill: "white",
    stroke: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27344 38.1479V47.9961V49.403L65.4895 83.2899L64.8537 71.2097L1.27344 38.1479Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27344 62.3081V72.1563V73.5632L55.9524 102.364H65.4895V96.0056L1.27344 62.3081Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97576 13.8169L1.03125 23.7023V25.1145L65.49 59.1295L64.8518 47.0036L1.97576 13.8169Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.27641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0665 13.9879H41.5542L65.2146 24.5728V35.1921L24.5732 13.9879H27.0665Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63574 95V86.071L31.5065 102.364H13.8349L1.63574 96.5973V95Z",
    fill: "#004137",
    stroke: "#004137",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 15.7908C0.988281 14.1557 2.31386 12.8301 3.94903 12.8301H62.1772C63.8123 12.8301 65.1379 14.1557 65.1379 15.7908V29.6077H0.988281V15.7908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3231 43.8702H20.3478C19.2944 43.8702 18.4404 44.7242 18.4404 45.7776V83.9258C18.4404 84.9792 19.2944 85.8332 20.3478 85.8332H48.3231C49.3766 85.8332 50.2305 84.9792 50.2305 83.9258V45.7776C50.2305 44.7242 49.3766 43.8702 48.3231 43.8702Z",
    fill: "white",
    stroke: "#004137",
    strokeWidth: 1.2716,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6172 52.7714H45.7777",
    stroke: "black",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6172 59.1293H45.7777",
    stroke: "black",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6172 65.4877H45.7777",
    stroke: "black",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6172 71.8456H45.7777",
    stroke: "black",
    strokeWidth: 1.2716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 75.0703H27.9727V82.5512H28.4434V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9697 75.0703H28.7344V82.5512H28.9697V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7393 75.0703H29.5039V82.5512H29.7393V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 75.0703H30.7656V82.5512H31.001V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.001 75.0703H31.7656V82.5512H32.001V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2676 75.0244H32.7969V82.5053H33.2676V75.0244Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8252 75.0703H33.5898V82.5512H33.8252V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3019 75.0244H34.5664V82.5053H35.3019V75.0244Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5947 75.0703H36.3594V82.5512H36.5947V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0606 75.0703H35.5898V82.5512H36.0606V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5949 75.0703H36.8594V82.5512H37.5949V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8574 75.0703H38.3867V82.5512H38.8574V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4189 75.0703H39.1836V82.5512H39.4189V75.0703Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 29.6074H65.1379",
    stroke: "#004137",
    strokeWidth: 1.2716
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_4248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/step-6.99cfd0722ed65c67ce65c10e2d3c9b74.svg";
export { ForwardRef as ReactComponent };